(() => {
  const root = document.documentElement;
  if (root.dataset.lhButtonMotionReady === 'true') return;
  root.dataset.lhButtonMotionReady = 'true';

  document.addEventListener('pointerenter', (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-lh-button-fx^="gradient-flow-"]');
    if (!button || button.contains(event.relatedTarget)) return;

    const bounds = button.getBoundingClientRect();
    const direction = event.clientX <= bounds.left + bounds.width / 2 ? 'normal' : 'reverse';
    button.style.setProperty('--lh-fx-flow-direction', direction);
  }, true);
})();
